// extracted by mini-css-extract-plugin
export default {"sidebar":"FundingSidebar_sidebar__5Sbn6","sidebar-nav":"FundingSidebar_sidebar-nav__W1DI-","sidebar-item":"FundingSidebar_sidebar-item__mABGP"};